import React from 'react'
// // import { useLocation } from '@reach/router'
// import TabsComponent from '@material-ui/core/Tabs'
// import { makeStyles } from 'webbook-airways'
import { Tabs } from '@xooom/ui'

// const useStyles = makeStyles(theme => ({
//   root: {
//     minHeight: 0,
//     height: '100%'
//   },
//   flexContainer: {
//     height: '100%'
//   },
//   indicator: {
//     backgroundColor: ({ indicatorColor }) =>
//       indicatorColor || theme.palette.primary.main
//   }
// }))

// function getIndex(path, children) {
//   return children.findIndex(({ props: { to } }) => {
//     const linkPath = to ?? ''
//     const linkPathTrimmed = linkPath.replace('/', '')
//     const pathTrimmed = path.trim()

//     if (!pathTrimmed || pathTrimmed === '1') return false
//     if (pathTrimmed === linkPathTrimmed) {
//       return true
//     } else if (linkPathTrimmed.includes(pathTrimmed)) {
//       return true
//     }
//     return false
//   })
// }

// function useMatchIndex(children) {
//   const { pathname } = window.location
//   const [index, setIndex] = React.useState(0)
//   React.useEffect(() => {
//     if (Array.isArray(children)) {
//       const paths = pathname.split('/').reverse()
//       for (let i = 0; i < paths.length; i++) {
//         const path = paths[i]
//         const index = getIndex(path, children)
//         if (index !== -1) return setIndex(index)
//       }
//     }
//     setIndex(0)
//   }, [pathname, children])
//   return index
// }

export function TabsBasic({ indicatorColor, value: custom_value, children }) {
  // const value = useMatchIndex(children)
  // const classes = useStyles({ indicatorColor })

  return (
    <Tabs>
      <Tabs.List>{children}</Tabs.List>
    </Tabs>
  )
  // return (
  //   <TabsComponent
  //     variant="scrollable"
  //     textColor="inherit"
  //     classes={classes}
  //     value={custom_value ?? value}
  //   >
  //     {children}
  //   </TabsComponent>
  // )
}
